import React from 'react';
import { formatDate, formatTime } from '../../utils/helpers';
import './TrackingTimeline.css';

const TrackingTimeline = ({ timeline }) => {
  if (!timeline || timeline.length === 0) {
    return (
      <div className="timeline-empty">
        <div className="empty-icon">📭</div>
        <h3>No Tracking Information Available</h3>
        <p>Tracking updates will appear here as your shipment progresses</p>
      </div>
    );
  }

  // Group timeline events by date
  const groupedTimeline = timeline.reduce((groups, event) => {
    const date = formatDate(event.date);
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(event);
    return groups;
  }, {});

  return (
    <div className="tracking-timeline">
      {Object.entries(groupedTimeline).map(([date, events]) => (
        <div key={date} className="timeline-day">
          <div className="timeline-date">
            <div className="date-badge">
              {date}
            </div>
          </div>
          
          <div className="timeline-events">
            {events.map((event, index) => (
              <div key={index} className="timeline-event">
                <div className="event-indicator">
                  <div className="event-dot"></div>
                  {index < events.length - 1 && <div className="event-line"></div>}
                </div>
                
                <div className="event-content">

                  
                  <div className="event-main">
                    <div className="event-status">
                      {event.status}
                    </div>
                    
                    <div className="event-location">
                      {event.location}
                    </div>
                    
                    {event.description && (
                      <div className="event-description">
                        {event.description}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrackingTimeline;